import React, { useEffect } from 'react';
import './ProductEng.css';

const ProductEng = () => {
    useEffect(() => {
        console.log('ProductEng useEffect running');
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    console.log(`${entry.target.className} isIntersecting: ${entry.isIntersecting}`);
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => {
            console.log('Observing:', element);
            observer.observe(element);
        });

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Conceptual Design Process",
            description: "Defining product concepts to meet IoT system requirements and user needs."
        },
        {
            title: "System Architecture Process",
            description: "Designing robust architectures for integrated IoT and embedded systems."
        },
        {
            title: "Hardware Development Process",
            description: "Developing reliable hardware components for IoT device functionality."
        },
        {
            title: "Firmware Development Process",
            description: "Creating optimized firmware to control embedded system operations."
        },
        {
            title: "Software Integration Process",
            description: "Integrating software solutions for seamless IoT product performance."
        },
        {
            title: "Prototyping Process",
            description: "Building prototypes to validate design and functionality of IoT products."
        },
        {
            title: "Testing and Validation Process",
            description: "Conducting rigorous tests to ensure product reliability and compliance."
        },
        {
            title: "Manufacturing Setup Process",
            description: "Establishing efficient manufacturing processes for IoT product production."
        },
        {
            title: "Product Lifecycle Management Process",
            description: "Managing product lifecycle to ensure long-term performance and updates."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                Product Engineering
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our product engineering services deliver comprehensive, reliable, and innovative solutions for IoT and embedded systems, from concept to production and beyond.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ProductEng;